// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '09af7733-a4b6-4cd2-a4bb-e507eb8f5f3c',
      type: 'Sprite',
      name: 'blackLayer',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 26,
        y: 3.450135
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Free_Column_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width',
          height: 'height'
        }
      }
    },
    {
      id: '2be6f9f8-9d64-485d-ae61-31eef561b167',
      type: 'Container',
      name: 'glowContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '3a7825ea-98a5-481d-9004-dc9156122a9f',
      type: 'Container',
      name: 'flashContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6667789f-5540-47f2-bf18-00fa1a30fdde',
      type: 'Container',
      name: 'sparkleBack',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'c62381a1-1c8a-4206-bbb9-91628139eaf1',
      type: 'Container',
      name: 'sparkleJackpot',
      className: '',
      x: 0,
      y: -230,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'a64b0be2-af03-4ec7-a8fb-8d144498405a',
      type: 'Container',
      name: 'rewardContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '4c274140-586d-4486-b9e7-fd56d5c05fb3',
      type: 'Container',
      name: 'buttonContainer',
      className: '',
      x: 0,
      y: 415,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      type: 'Container',
      name: 'jackpotContainer',
      className: '',
      x: 0,
      y: -240,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '479c54af-6b7e-46e0-bb77-d304c8e099e5',
      type: 'Container',
      name: 'sparkleFront',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '178b1422-3b12-409e-9c01-aef37263a6cc',
      type: 'Sprite',
      name: 'glow1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 0.4,
      visible: true,
      tint: 16768373,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '2be6f9f8-9d64-485d-ae61-31eef561b167'
    },
    {
      id: '75df686f-d87b-4cfd-941a-d4e0150ecd80',
      type: 'Sprite',
      name: 'glow2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0.6,
      visible: true,
      tint: 16768373,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '2be6f9f8-9d64-485d-ae61-31eef561b167'
    },
    {
      id: '44ad7428-8828-4910-853e-a5443f8f5a12',
      type: 'Sprite',
      name: 'flashDiamond',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'flashDiamond',
      parent: '3a7825ea-98a5-481d-9004-dc9156122a9f'
    },
    {
      id: '752916ef-ddf5-481b-bc32-7921a19a3fa2',
      type: 'Sprite',
      name: 'flashTriangle1',
      className: '',
      x: 21,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 4
      },
      angle: 31.7,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'flashTriangle',
      parent: '3a7825ea-98a5-481d-9004-dc9156122a9f'
    },
    {
      id: '2b910977-c082-41d5-85f1-2e9621691c53',
      type: 'Sprite',
      name: 'flashTriangle2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 4
      },
      angle: -31.4,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'flashTriangle',
      parent: '3a7825ea-98a5-481d-9004-dc9156122a9f'
    },
    {
      id: '15220ffc-2d1f-42f6-93e2-bf1158c2942e',
      type: 'Sprite',
      name: 'flashTriangle3',
      className: '',
      x: -9.999999,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 4
      },
      angle: 180,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'flashTriangle',
      parent: '3a7825ea-98a5-481d-9004-dc9156122a9f'
    },
    {
      id: '858de22a-a3d3-40fa-a2d6-fbd28538eb52',
      type: 'Sprite',
      name: 'wonRewardIcon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: 'a64b0be2-af03-4ec7-a8fb-8d144498405a',
      data: {
        maxSize: 200
      }
    },
    {
      id: '5f77bb8e-fc03-4b76-b1e7-224758c4e093',
      type: 'Layout',
      name: 'claimButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '4c274140-586d-4486-b9e7-fd56d5c05fb3',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'c341a1aa-05eb-4d1f-bbca-2731a349f8a8',
      type: 'Sprite',
      name: 'J',
      className: '',
      x: -215,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_J',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: 'a6305941-0221-4c92-a8c9-c91d678df985',
      type: 'Sprite',
      name: 'A',
      className: '',
      x: -151,
      y: 21,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_A',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: '06783e41-01cb-44a4-bf25-51b8bf7b3976',
      type: 'Sprite',
      name: 'C',
      className: '',
      x: -83,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_C',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: '84344b1b-78ca-479d-b3d8-7cfd3b4ba859',
      type: 'Sprite',
      name: 'T',
      className: '',
      x: 204,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_T',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: '6341bd17-3d5f-479e-92ab-d4f4909b2586',
      type: 'Sprite',
      name: 'O',
      className: '',
      x: 130,
      y: 21,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_O',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: '66f87f25-4214-4180-8b58-a2722d10119e',
      type: 'Sprite',
      name: 'P',
      className: '',
      x: 60,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_P',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: '0188762d-f853-4da2-bdb4-a99ef5df87c7',
      type: 'Sprite',
      name: 'K',
      className: '',
      x: -10,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Jackpot_K',
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: 'b0690d1a-cb75-48e8-a2b2-56a0b8ff30fc',
      type: 'Text',
      name: 'jackpotKR',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '잭팟',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'bolder',
        fontFamily: 'Arial',
        fill: 'white',
        stroke: '#ba00c2',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ko_KR: {
          visible: true
        }
      }
    },
    {
      id: 'd8f0a5c0-8384-464b-b3e1-a99a614c6180',
      type: 'Text',
      name: 'jackpotJP',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ジャックポット',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'bolder',
        fontFamily: 'Arial',
        fill: 'white',
        stroke: '#ba00c2',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: -15,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2112726a-33fb-42fa-9e38-5d3b7aa425e7',
      stateByName: {
        ja_JP: {
          visible: true
        }
      }
    },
    {
      id: 'ca886948-6b9a-4a14-860c-9c6865bab7b7',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim',
      localize: true,
      maxWidth: 310,
      maxHeight: 90,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '5f77bb8e-fc03-4b76-b1e7-224758c4e093'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'en_US',
    'it_IT',
    'fr_FR',
    'de_DE',
    'es_ES',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP'
  ],
  animations: [
    {
      id: 'baeb91fb-ded1-41e4-9bfc-7fc7000cbcbe',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 930,
      blocks: [
        {
          id: 'a7756aec-e7a7-4021-937c-f8e7758c35d4',
          type: 'Setter',
          name: 'blackAlpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'blackLayer',
          disabled: false
        },
        {
          id: 'cf9a6ff7-d1e5-408b-b99f-636f93640fca',
          type: 'Setter',
          name: 'reawardScale',
          track: 5,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'rewardContainer',
          disabled: false
        },
        {
          id: 'b5f8775d-0962-4dbb-a56b-6005542900ef',
          type: 'Setter',
          name: 'flashDAlpha',
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashDiamond',
          disabled: false
        },
        {
          id: '6cdc4eb4-e48e-4148-bc61-946cd71c8713',
          type: 'Setter',
          name: 'flashT1Alpha',
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashTriangle1',
          disabled: false
        },
        {
          id: '9a027d8a-22b4-4e54-97d3-47a648e9051d',
          type: 'Setter',
          name: 'flashT2Alpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashTriangle2',
          disabled: false
        },
        {
          id: 'fb8a7076-6f11-4147-b29f-18712c31110d',
          type: 'Setter',
          name: 'flashT3Alpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashTriangle3',
          disabled: false
        },
        {
          id: '329466ae-a4aa-41bc-8f63-4ba7033dc875',
          type: 'Setter',
          name: 'glowAlpha',
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'glowContainer',
          disabled: false
        },
        {
          id: '44a19744-b5e4-4bb6-a47e-ca4d562e2010',
          type: 'Setter',
          name: 'buttonScale',
          track: 14,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'buttonContainer',
          disabled: false
        },
        {
          id: '7d630a91-8d63-46d9-8136-e7b337ea57a9',
          type: 'Setter',
          name: 'jackpotScale',
          track: 16,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'jackpotContainer',
          disabled: false
        },
        {
          id: 'fe23b550-5c64-4da9-8181-20c7e092ba72',
          type: 'Setter',
          name: 'jScale',
          track: 29,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'J',
          disabled: false
        },
        {
          id: '63148d6e-11ce-435f-91be-2eb7b52ba49c',
          type: 'Setter',
          name: 'AScale',
          track: 27,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'A',
          disabled: false
        },
        {
          id: '89e10855-a490-4df5-b05b-5ec9c2c47e78',
          type: 'Setter',
          name: 'CScale',
          track: 25,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'C',
          disabled: false
        },
        {
          id: '931be11f-ef92-45f2-8fbf-3d0f0009598f',
          type: 'Setter',
          name: 'KScale',
          track: 23,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'K',
          disabled: false
        },
        {
          id: '8e939ca7-175c-4d24-a161-d50f23ad6d53',
          type: 'Setter',
          name: 'PScale',
          track: 21,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'P',
          disabled: false
        },
        {
          id: '03880390-16b3-4a11-8cd6-2309b9b3d425',
          type: 'Setter',
          name: 'PScale_copy',
          track: 19,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'O',
          disabled: false
        },
        {
          id: '70afba6a-d2b6-4754-87fe-6696d2264f95',
          type: 'Setter',
          name: 'PScale_copy_copy',
          track: 17,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'T',
          disabled: false
        },
        {
          id: '08ad370d-d43c-411d-a17b-2f067673d00f',
          type: 'Tween',
          name: 'blackAlpha_1',
          duration: 150,
          track: 2,
          target: {
            alpha: 0.8
          },
          startAt: 20,
          sourceName: 'blackLayer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '177e5170-f179-4afc-983d-52e2d0c4f5f1',
          type: 'Setter',
          name: 'SFX_Adding_Event_Token',
          track: 4,
          target: {},
          startAt: 62,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'df34c322-5b1f-4dc5-a2a0-9caa7d8bc0ae',
          type: 'Setter',
          name: 'FXPART_JackpotParticlesBurst',
          track: 3,
          target: {},
          startAt: 70,
          sourceName: 'sparkleFront',
          disabled: false
        },
        {
          id: '359c6f29-4843-4593-a3e8-2e97959d966c',
          type: 'Tween',
          name: 'rewardScale',
          duration: 200,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 70,
          sourceName: 'rewardContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a631a54f-1629-4d4b-b68b-6a5e53e5c38c',
          type: 'Tween',
          name: 'jackpotScale_1',
          duration: 250,
          track: 16,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'jackpotContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'cfc857f3-1ee6-46c3-8836-7831823764a1',
          type: 'Setter',
          name: 'FXPART_JackpotRewardParticles',
          track: 4,
          target: {},
          startAt: 150,
          sourceName: 'sparkleBack',
          disabled: false
        },
        {
          id: 'd9b6d9e2-dd0f-417e-a16c-9ef0351ef036',
          type: 'Setter',
          name: 'flashDAlpha',
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 170,
          sourceName: 'flashDiamond',
          disabled: false
        },
        {
          id: 'cdbe88ef-e995-450a-865f-46c992b81fa7',
          type: 'Tween',
          name: 'glowAlpha_2',
          duration: 150,
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 170,
          sourceName: 'glowContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '068405cc-86d2-4768-a3e9-a0a5e1d85632',
          type: 'Tween',
          name: 'flashDScale',
          duration: 150,
          track: 10,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 190,
          sourceName: 'flashDiamond',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7cf8d5bd-94d3-4dc7-bf0f-4bcb65cbeb8d',
          type: 'Setter',
          name: 'flashT1Alpha',
          track: 8,
          target: {
            alpha: 1
          },
          startAt: 200,
          sourceName: 'flashTriangle1',
          disabled: false
        },
        {
          id: '3a60416f-7be2-4ae1-922a-29028e008104',
          type: 'Setter',
          name: 'flashT2Alpha',
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 200,
          sourceName: 'flashTriangle2',
          disabled: false
        },
        {
          id: 'f25c13b8-1840-4b2d-9ae8-1edf8bd7695c',
          type: 'Setter',
          name: 'flashT3Alpha',
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 200,
          sourceName: 'flashTriangle3',
          disabled: false
        },
        {
          id: '65c3d1d8-dfdf-4c93-a2ca-4b127c2a0e4b',
          type: 'Tween',
          name: 'flashT1Scale',
          duration: 150,
          track: 8,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 220,
          sourceName: 'flashTriangle1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f8247da9-1166-4d0e-9d17-a86bda64639a',
          type: 'Tween',
          name: 'flashT2Scale',
          duration: 150,
          track: 7,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 220,
          sourceName: 'flashTriangle2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '62fb6dff-f0df-4f13-81bb-dc8b939d3e6d',
          type: 'Tween',
          name: 'flashT3Scale',
          duration: 150,
          track: 6,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 220,
          sourceName: 'flashTriangle3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e2eeccc8-b6bb-451d-a2be-eb883614ed38',
          type: 'Tween',
          name: 'AScale_1',
          duration: 230,
          track: 27,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 250,
          sourceName: 'A',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '71321df6-779f-49db-bf7f-9c2a69df9760',
          type: 'Tween',
          name: 'rewardScale_2',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 270,
          sourceName: 'rewardContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ab5fab83-a96d-4b1f-9ca4-7bd05c19f30d',
          type: 'Tween',
          name: 'CScale_1',
          duration: 230,
          track: 25,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 300,
          sourceName: 'C',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a7b6c815-c6c1-4f82-956e-e0099b7ae2dd',
          type: 'Tween',
          name: 'jScale_1',
          duration: 250,
          track: 29,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 300,
          sourceName: 'J',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5b21ffa9-9d04-4b6e-888c-39e9cbfc0690',
          type: 'Tween',
          name: 'buttonScale_1',
          duration: 250,
          track: 14,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 300,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7b7b9fd4-c26f-463c-a40e-f65ece61a58a',
          type: 'Setter',
          name: 'FXPART_JackpotTextParticles',
          track: 30,
          target: {},
          startAt: 350,
          sourceName: 'sparkleJackpot',
          disabled: false
        },
        {
          id: '1afb7ae3-69d8-4d6c-b1ba-2b42c22f2ded',
          type: 'Tween',
          name: 'KScale_1',
          duration: 230,
          track: 23,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 350,
          sourceName: 'K',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ae474088-6e72-4bc8-af24-de23e4434880',
          type: 'Tween',
          name: 'jackpotScale_2',
          duration: 200,
          track: 16,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 350,
          sourceName: 'jackpotContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd95cb985-de10-4719-8e97-c3b24be1c71b',
          type: 'Tween',
          name: 'PScale_1',
          duration: 230,
          track: 21,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 400,
          sourceName: 'P',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2de55cf4-7e2a-47ea-849e-e48863e134cf',
          type: 'Tween',
          name: 'OScale',
          duration: 230,
          track: 19,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 450,
          sourceName: 'O',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7e4407bb-99fe-4ca9-a8fc-035322c55f60',
          type: 'Tween',
          name: 'AScale_2',
          duration: 200,
          track: 27,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 480,
          sourceName: 'A',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f904d6e7-0b6b-4333-b563-8c64a771646e',
          type: 'Tween',
          name: 'TScale',
          duration: 230,
          track: 17,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 500,
          sourceName: 'T',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '83238270-4198-4155-a352-17dbdd11125f',
          type: 'Tween',
          name: 'CScale_2',
          duration: 200,
          track: 25,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 530,
          sourceName: 'C',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4808d89c-c60c-4221-9a11-e82301996c73',
          type: 'Tween',
          name: 'buttonScale_2',
          duration: 200,
          track: 14,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 550,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '93b7fbdf-d171-44d9-9c6f-e683798153c3',
          type: 'Tween',
          name: 'jScale_2',
          duration: 200,
          track: 29,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 550,
          sourceName: 'J',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aafa5214-97e6-4bdd-b6fc-f0f8a9d17fc2',
          type: 'Tween',
          name: 'KScale_2',
          duration: 200,
          track: 23,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 580,
          sourceName: 'K',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c21e2932-72c0-42cb-a1d1-e8cbeb3bf335',
          type: 'Tween',
          name: 'PScale_2',
          duration: 200,
          track: 21,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 630,
          sourceName: 'P',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'af7c541f-92f5-4690-bbc4-d922ebaf76ad',
          type: 'Tween',
          name: 'OScale_1',
          duration: 200,
          track: 19,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 680,
          sourceName: 'O',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2a8d324f-d2e8-4d2d-a952-4143a0d7d399',
          type: 'Tween',
          name: 'TScale_1',
          duration: 200,
          track: 17,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 730,
          sourceName: 'T',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'd7043b53-534e-4fa9-96d0-f9c9c91e825c',
      name: 'Disappear',
      playingSpeed: 1,
      totalDuration: 730,
      blocks: [
        {
          id: '37964dd4-e16e-4da5-8bd3-7f80ff423d4d',
          type: 'Setter',
          name: 'flashDAlpha',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashDiamond',
          disabled: false
        },
        {
          id: '836d5915-ae16-4c44-b2fb-604dbf0b7e30',
          type: 'Setter',
          name: 'flashT1Alpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashTriangle1',
          disabled: false
        },
        {
          id: '15575fc2-ff0d-4392-8296-c8a9d71f4331',
          type: 'Setter',
          name: 'flashT2Alpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashTriangle2',
          disabled: false
        },
        {
          id: 'bc80263e-fa7f-45aa-b6ee-12173eba79b0',
          type: 'Setter',
          name: 'flashT3Alpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'flashTriangle3',
          disabled: false
        },
        {
          id: '5b21ffa9-9d04-4b6e-888c-39e9cbfc0690',
          type: 'Tween',
          name: 'buttonScale_1',
          duration: 250,
          track: 12,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4808d89c-c60c-4221-9a11-e82301996c73',
          type: 'Tween',
          name: 'buttonScale_2',
          duration: 200,
          track: 12,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 250,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '534b4fd2-cfba-44ee-8177-f0bc05e3f950',
          type: 'Tween',
          name: 'jackpotScale_3',
          duration: 200,
          track: 7,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 300,
          sourceName: 'jackpotContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'cdbe88ef-e995-450a-865f-46c992b81fa7',
          type: 'Tween',
          name: 'glowAlpha_2',
          duration: 150,
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 430,
          sourceName: 'glowContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '85b5657b-ba91-4ccb-884d-53e17fc52a8c',
          type: 'Tween',
          name: 'jackpotScale_4',
          duration: 150,
          track: 7,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 500,
          sourceName: 'jackpotContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '08ad370d-d43c-411d-a17b-2f067673d00f',
          type: 'Tween',
          name: 'blackAlpha_1',
          duration: 150,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 580,
          sourceName: 'blackLayer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class LuckyWheelRewardAnimationLayout {
  static raw = raw;
  root!: Container;
  blackLayer!: Sprite & { data: typeof raw['list'][1]['data'] };
  glowContainer!: Container;
  flashContainer!: Container;
  sparkleBack!: Container;
  sparkleJackpot!: Container;
  rewardContainer!: Container;
  buttonContainer!: Container;
  jackpotContainer!: Container;
  sparkleFront!: Container;
  glow1!: Sprite;
  glow2!: Sprite;
  flashDiamond!: Sprite;
  flashTriangle1!: Sprite;
  flashTriangle2!: Sprite;
  flashTriangle3!: Sprite;
  wonRewardIcon!: Sprite & { data: typeof raw['list'][16]['data'] };
  claimButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][17]['data'] };
  J!: Sprite;
  A!: Sprite;
  C!: Sprite;
  T!: Sprite;
  O!: Sprite;
  P!: Sprite;
  K!: Sprite;
  jackpotKR!: Text;
  jackpotJP!: Text;
  locaSkin_SPL!: (Container)[];
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] })[];
  upperCase_SPL!: (Text)[];
  StateName!: 'en_US' | 'it_IT' | 'fr_FR' | 'de_DE' | 'es_ES' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'ja_JP';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    blackLayer: object;
    rewardContainer: object;
    flashDiamond: object;
    flashTriangle1: object;
    flashTriangle2: object;
    flashTriangle3: object;
    glowContainer: object;
    buttonContainer: object;
    jackpotContainer: object;
    J: object;
    A: object;
    C: object;
    K: object;
    P: object;
    O: object;
    T: object;
    root: object;
    sparkleFront: object;
    sparkleBack: object;
    sparkleJackpot: object;
  };

  BlockTypeByName: {
    blackAlpha: object;
    reawardScale: object;
    flashDAlpha: object;
    flashT1Alpha: object;
    flashT2Alpha: object;
    flashT3Alpha: object;
    glowAlpha: object;
    buttonScale: object;
    jackpotScale: object;
    jScale: object;
    AScale: object;
    CScale: object;
    KScale: object;
    PScale: object;
    PScale_copy: object;
    PScale_copy_copy: object;
    blackAlpha_1: object;
    SFX_Adding_Event_Token: object;
    FXPART_JackpotParticlesBurst: object;
    rewardScale: object;
    jackpotScale_1: object;
    FXPART_JackpotRewardParticles: object;
    flashDAlpha: object;
    glowAlpha_2: object;
    flashDScale: object;
    flashT1Alpha: object;
    flashT2Alpha: object;
    flashT3Alpha: object;
    flashT1Scale: object;
    flashT2Scale: object;
    flashT3Scale: object;
    AScale_1: object;
    rewardScale_2: object;
    CScale_1: object;
    jScale_1: object;
    buttonScale_1: object;
    FXPART_JackpotTextParticles: object;
    KScale_1: object;
    jackpotScale_2: object;
    PScale_1: object;
    OScale: object;
    AScale_2: object;
    TScale: object;
    CScale_2: object;
    buttonScale_2: object;
    jScale_2: object;
    KScale_2: object;
    PScale_2: object;
    OScale_1: object;
    TScale_1: object;
  };

  flowData = raw.animations[0];
}

export abstract class Disappear {
  Layout: {
    flashDiamond: object;
    flashTriangle1: object;
    flashTriangle2: object;
    flashTriangle3: object;
    buttonContainer: object;
    jackpotContainer: object;
    glowContainer: object;
    blackLayer: object;
  };

  BlockTypeByName: {
    flashDAlpha: object;
    flashT1Alpha: object;
    flashT2Alpha: object;
    flashT3Alpha: object;
    buttonScale_1: object;
    buttonScale_2: object;
    jackpotScale_3: object;
    glowAlpha_2: object;
    jackpotScale_4: object;
    blackAlpha_1: object;
  };

  flowData = raw.animations[1];
}
